export default __webpack_public_path__ + "static/umami-cover-bg-mobile-1e857008c8fb3ca1c488f7c1ad74ddbf.png";